export default __webpack_public_path__ + "static/media/software.5354ac4d.svg";